import { Http, Moment, Url } from '@intelipost-js/secure-providers';

export default {
  getTotalQuoteByPlatformAndSalesChannel(context, dateRange) {
    const {
      start = Moment().subtract(1, 'days').format('YYYY-MM-DD'),
      end = Moment().format('YYYY-MM-DD'),
    } = dateRange;

    const pathParams = [
      'billing',
      'excel',
      start,
      end,
    ];

    return Http.get(Url.toQueryString('api/v1/report', {}, pathParams))
    .then(() => {
      context.commit('setLoading', false);
      context.commit('setHasGeneratedReport', true);
    }).catch(() => context.commit('setLoading', false));
  },
  getTotalOrderByPlatform(context, dateRange) {
    const {
      start = Moment().subtract(1, 'days').format('YYYY-MM-DD'),
      end = Moment().format('YYYY-MM-DD'),
    } = dateRange;

    const pathParams = [
      'total_order_shipped',
      'excel',
      'platform',
      start,
      end,
    ];

    return Http.get(Url.toQueryString('api/v1/report', {}, pathParams))
    .then(() => {
      context.commit('setLoading', false);
      context.commit('setHasGeneratedReport', true);
    }).catch(() => context.commit('setLoading', false));
  },
  getTotalOrderByProvider(context, dateRange) {
    const {
      start = Moment().subtract(1, 'days').format('YYYY-MM-DD'),
      end = Moment().format('YYYY-MM-DD'),
    } = dateRange;

    const pathParams = [
      'total_order_shipped',
      'excel',
      'provider',
      start,
      end,
    ];

    return Http.get(Url.toQueryString('api/v1/report', {}, pathParams))
    .then(() => {
      context.commit('setLoading', false);
      context.commit('setHasGeneratedReport', true);
    }).catch(() => context.commit('setLoading', false));
  },
};




// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/total-quote/store/actions.js